module.exports = __webpack_public_path__ + "img/F3g.c544d30a.svg";